import { render } from "./ProfileFormEducation.vue?vue&type=template&id=4c602e0c&scoped=true"
import script from "./ProfileFormEducation.vue?vue&type=script&lang=js"
export * from "./ProfileFormEducation.vue?vue&type=script&lang=js"

import "./ProfileFormEducation.vue?vue&type=style&index=0&id=4c602e0c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c602e0c"]])

export default __exports__